export enum LocalizedContentEventType {
	LOCALIZED_CONTENT_SERVICE_READY = 'PortalLocalizedContentServiceReadyEvent',
	CURRENCY_CONVERSION_SERVICE_READY = 'PortalCurrencyConversionServiceReadyEvent'
}
